/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import ItemTypes from '../../constants/itemTypes';
import Attachments from '../Common/attachments';
import DescriptionField from '../Common/descriptionField';
import SelectField from '../Common/selectField';
import AcceptanceCriteria from '../Criteria/acceptanceCriteria';
import WorkerSelect from '../Common/workerSelect';
import OwnerSelect from '../Common/ownerSelect';
import { allows } from '../../utils/authorization';
import ProductSelect from '../Common/productSelect';
import {
  generateParentOptions,
  generateTeamOptions
} from '../../utils/resultModalHelpers';

class DetailsTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFull: false,
      isCriteriaFull: false
    };
  }

  toggleIsFull = () =>
    this.setState((prevState) => ({ isFull: !prevState.isFull }));

  toggleCriteriaFull = () =>
    this.setState((prevState) => ({
      isCriteriaFull: !prevState.isCriteriaFull
    }));

  render() {
    const { isFull, isCriteriaFull } = this.state;
    const {
      capability,
      attachmentList,
      criteria,
      addCriteria,
      removeCriteria,
      onSelectChange,
      teams,
      team,
      product,
      parents,
      parent
    } = this.props;

    const allowEdit = allows('update', capability);

    const { teamOptions, selectedTeam } = generateTeamOptions(
      product.teams || teams,
      team
    );

    const { selectedParent, parentOptions } = generateParentOptions(
      parents,
      parent
    );

    return (
      <div className="details-tab">
        {!isCriteriaFull && (
          <div className={`row top-description ${isFull ? 'full' : ''}`}>
            <DescriptionField
              id={capability.id}
              type="WorkPackage"
              description={capability.description}
              onFieldChange={this.props.handleUpdate}
              allowEdit={allowEdit}
              toggleIsFull={this.toggleIsFull}
              isFull={isFull}
            />
            {!isFull && (
              <div className="selects-column detail-tab-right">
                <ProductSelect
                  allowEdit={allowEdit}
                  onSelectChange={onSelectChange}
                  selectedTeam={selectedTeam}
                  selectedProductId={capability.product_id}
                />
                <SelectField
                  label="Team"
                  value={selectedTeam}
                  options={teamOptions}
                  allowEdit={allowEdit && teamOptions.length > 0}
                  handleChange={onSelectChange}
                  clearable={!!capability.product_id}
                />
                <WorkerSelect
                  label="Owner"
                  selectedWorker={{ id: capability.owner_id }}
                  allowEdit={allowEdit}
                  onUpdate={onSelectChange}
                  result={capability}
                />
                <OwnerSelect
                  label="Product Manager"
                  selectedOwner={{ id: capability.product_owner_id }}
                  allowEdit={allowEdit}
                  onUpdate={onSelectChange}
                  result={capability}
                />
                <SelectField
                  label="Parent"
                  value={selectedParent}
                  options={parentOptions}
                  allowEdit={allowEdit}
                  handleChange={onSelectChange}
                />
              </div>
            )}
          </div>
        )}
        {!isFull && (
          <div className="row bottom-ac">
            <div className="ac-container">
              <AcceptanceCriteria
                criteria={criteria}
                addCriteria={addCriteria}
                removeCriteria={removeCriteria}
                workPackage={capability}
                isCriteriaFull={isCriteriaFull}
                toggleCriteriaFull={this.toggleCriteriaFull}
                isNew={!capability.id}
                detailCard
              />
            </div>
            {!isCriteriaFull && (
              <Attachments
                itemId={capability.id}
                type={ItemTypes.RESULT}
                allowCreate={allows('create_attachments', capability)}
                allowDelete={allows('destroy_attachments', capability)}
                attachmentList={attachmentList}
                addAttachment={this.props.addAttachment}
                removeAttachment={this.props.removeAttachment}
                isNew={!capability.id}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

DetailsTab.propTypes = {
  capability: PropTypes.object.isRequired,
  handleUpdate: PropTypes.func
};

export default DetailsTab;
